export const SPACER_CLASS = 'spacer';
